import { createContext } from 'react'
import { TSystemEmailsContainerContext } from './types'
import { ESystemEmailType } from './components/tableListing/types'


export const SystemEmailsContainerContext = createContext<TSystemEmailsContainerContext>({
    currentTab: { current: ESystemEmailType.accountConfirm }
})